import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sv-loading"
}
const _hoisted_2 = {
  key: 1,
  class: "sv-empty"
}
const _hoisted_3 = { class: "sv-header" }
const _hoisted_4 = { class: "sv-header-main" }
const _hoisted_5 = { class: "sv-title" }
const _hoisted_6 = { class: "sv-created" }
const _hoisted_7 = { class: "sv-card" }
const _hoisted_8 = { class: "sv-meta-grid" }
const _hoisted_9 = { class: "sv-meta-item" }
const _hoisted_10 = { class: "sv-meta-val" }
const _hoisted_11 = { class: "sv-meta-item" }
const _hoisted_12 = { class: "sv-meta-val" }
const _hoisted_13 = { class: "sv-meta-item" }
const _hoisted_14 = { class: "sv-meta-val sv-author" }
const _hoisted_15 = { class: "sv-avatar" }
const _hoisted_16 = {
  key: 0,
  class: "sv-meta-item"
}
const _hoisted_17 = { class: "sv-meta-val" }
const _hoisted_18 = {
  key: 1,
  class: "sv-meta-item"
}
const _hoisted_19 = { class: "sv-meta-val" }
const _hoisted_20 = {
  key: 2,
  class: "sv-meta-item sv-meta-item--full"
}
const _hoisted_21 = { class: "sv-tags" }
const _hoisted_22 = {
  key: 0,
  class: "sv-tag"
}
const _hoisted_23 = {
  key: 0,
  class: "sv-card"
}
const _hoisted_24 = { class: "sv-activities" }
const _hoisted_25 = { class: "sv-activity-title" }
const _hoisted_26 = { class: "sv-img-grid" }
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  key: 1,
  class: "sv-card"
}
const _hoisted_29 = { class: "sv-activities" }
const _hoisted_30 = { class: "sv-activity-title" }
const _hoisted_31 = {
  key: 0,
  class: "sv-img-grid"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  key: 1,
  class: "sv-no-img"
}
const _hoisted_34 = {
  key: 2,
  class: "sv-card"
}
const _hoisted_35 = { class: "sv-activities" }
const _hoisted_36 = { class: "sv-activity-title" }
const _hoisted_37 = {
  key: 0,
  class: "sv-img-grid"
}
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "sv-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubmissionPrintPreview = _resolveComponent("SubmissionPrintPreview")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sv-page", { embedded: _ctx.embedded }])
  }, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("svg", {
            width: "28",
            height: "28",
            viewBox: "0 0 20 20",
            fill: "none",
            class: "sv-spin"
          }, [
            _createElementVNode("circle", {
              cx: "10",
              cy: "10",
              r: "8",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-dasharray": "40",
              "stroke-dashoffset": "15",
              "stroke-linecap": "round"
            })
          ], -1)
        ]))]))
      : (!_ctx.submission)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[7] || (_cache[7] = _createElementVNode("svg", {
              width: "48",
              height: "48",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.5"
            }, [
              _createElementVNode("circle", {
                cx: "12",
                cy: "12",
                r: "10"
              }),
              _createElementVNode("line", {
                x1: "12",
                y1: "8",
                x2: "12",
                y2: "12"
              }),
              _createElementVNode("line", {
                x1: "12",
                y1: "16",
                x2: "12.01",
                y2: "16"
              })
            ], -1)),
            _cache[8] || (_cache[8] = _createElementVNode("p", null, "Submissão não encontrada.", -1)),
            _createElementVNode("button", {
              class: "sv-btn sv-btn--ghost",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
            }, "← Voltar")
          ]))
        : (!_ctx.isLoading && _ctx.showPreview)
          ? (_openBlock(), _createBlock(_component_SubmissionPrintPreview, {
              key: 2,
              submission: _ctx.submission,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPreview = false))
            }, null, 8, ["submission"]))
          : (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    class: "sv-back",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
                  }, [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("svg", {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.2"
                    }, [
                      _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
                    ], -1),
                    _createTextVNode(" Voltar ", -1)
                  ]))]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.submission.title), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["sv-status", _ctx.submission.status === 'enviado' ? 'sv-status--sent' : 'sv-status--draft'])
                    }, _toDisplayString(_ctx.submission.status === 'enviado' ? 'Enviado' : 'Rascunho'), 3)
                  ]),
                  _createElementVNode("p", _hoisted_6, "Criado em " + _toDisplayString(_ctx.formatDate(_ctx.submission.createdAt)), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "sv-card-label" }, "Informações", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "sv-meta-key" }, "Atração", -1)),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.submission.attraction || '—'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "sv-meta-key" }, "Data do relatório", -1)),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formatReportDate(_ctx.submission.reportDate)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "sv-meta-key" }, "Autor", -1)),
                      _createElementVNode("span", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.submission.author.name.charAt(0).toUpperCase()), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.submission.author.name), 1)
                      ])
                    ]),
                    (_ctx.submission.coAuthors && _ctx.submission.coAuthors.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "sv-meta-key" }, "Co-autores", -1)),
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.submission.coAuthors.map(_ctx.resolveCoAuthorName).join(', ')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.submission.collaborators && _ctx.submission.collaborators.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "sv-meta-key" }, "Colaboradores", -1)),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.submission.collaborators.join(', ')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.submission.tools && _ctx.submission.tools.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _cache[15] || (_cache[15] = _createElementVNode("span", { class: "sv-meta-key" }, "Ferramentas", -1)),
                          _createElementVNode("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.submission.tools, (tool) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: tool.id
                              }, [
                                (tool.text)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.getMachineTitle(tool.text)), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.submission.tools && _ctx.submission.tools.some(t => t.images && t.images.length))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "sv-card-label" }, "Equipamentos — Fotos", -1)),
                      _createElementVNode("div", _hoisted_24, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.submission.tools.filter(t => t.images && t.images.length), (tool) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `tool-imgs-${tool.id}`,
                            class: "sv-activity"
                          }, [
                            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.getMachineTitle(tool.text) || '—'), 1),
                            _createElementVNode("div", _hoisted_26, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tool.images, (img, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "sv-img-wrap",
                                  key: `tool-img-${idx}`
                                }, [
                                  _createElementVNode("img", {
                                    src: _ctx.resolveUrl(img),
                                    alt: "imagem do equipamento"
                                  }, null, 8, _hoisted_27)
                                ]))
                              }), 128))
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.submission.activities && _ctx.submission.activities.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "sv-card-label" }, "Atividades", -1)),
                      _createElementVNode("div", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.submission.activities, (activity) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "sv-activity",
                            key: activity.id
                          }, [
                            _createElementVNode("div", _hoisted_30, _toDisplayString(activity.description || 'Atividade'), 1),
                            (activity.images && activity.images.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.images, (img, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "sv-img-wrap",
                                      key: `${activity.id}-img-${index}`
                                    }, [
                                      _createElementVNode("img", {
                                        src: _ctx.resolveUrl(img),
                                        alt: "imagem da atividade"
                                      }, null, 8, _hoisted_32)
                                    ]))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_33, "Sem imagens"))
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.submission.observations && _ctx.submission.observations.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "sv-card-label" }, "Observações", -1)),
                      _createElementVNode("div", _hoisted_35, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.submission.observations, (obs) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: obs.id,
                            class: "sv-activity"
                          }, [
                            _createElementVNode("div", _hoisted_36, _toDisplayString(obs.text || '—'), 1),
                            (obs.images && obs.images.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(obs.images, (img, idx) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "sv-img-wrap",
                                      key: `obs-img-${idx}`
                                    }, [
                                      _createElementVNode("img", {
                                        src: _ctx.resolveUrl(img),
                                        alt: "imagem da observação"
                                      }, null, 8, _hoisted_38)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("button", {
                    class: "sv-btn sv-btn--ghost",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
                  }, "← Voltar"),
                  _createElementVNode("button", {
                    class: "sv-btn sv-btn--print",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showPreview = true))
                  }, [...(_cache[20] || (_cache[20] = [
                    _createElementVNode("svg", {
                      width: "14",
                      height: "14",
                      viewBox: "0 0 16 16",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "1.6"
                    }, [
                      _createElementVNode("rect", {
                        x: "3",
                        y: "1",
                        width: "10",
                        height: "14",
                        rx: "1.5"
                      }),
                      _createElementVNode("path", {
                        d: "M5 4h6M5 7h6M5 10h4",
                        "stroke-linecap": "round"
                      })
                    ], -1),
                    _createTextVNode(" Visualizar impressão ", -1)
                  ]))]),
                  (_ctx.canEdit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "sv-btn sv-btn--primary",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.edit && _ctx.edit(...args)))
                      }, "Editar"))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true)
  ], 2))
}